//#region src/query/Query.ts
var QueryBuilder = class QueryBuilder {
	constructor(encodedQuery) {
		this.encodedQuery = encodedQuery;
	}
	select(attributes) {
		if (this.encodedQuery.select) {
			const mergedAttributes = [...new Set([...this.encodedQuery.select, ...attributes])];
			return new QueryBuilder({
				...this.encodedQuery,
				select: mergedAttributes
			});
		} else return new QueryBuilder({
			...this.encodedQuery,
			select: attributes
		});
	}
	where(attribute, operator, value) {
		const existingClauses = this.encodedQuery.where ?? [];
		return new QueryBuilder({
			...this.encodedQuery,
			where: [...existingClauses, [
				attribute,
				operator,
				value
			]]
		});
	}
	order(attribute, direction) {
		const existingClauses = this.encodedQuery.order ?? [];
		return new QueryBuilder({
			...this.encodedQuery,
			order: [...existingClauses, [attribute, direction]]
		});
	}
	limit(limit) {
		return new QueryBuilder({
			...this.encodedQuery,
			limit
		});
	}
	id(id) {
		return this.where("id", "=", id).one();
	}
	one() {
		return this.limit(1);
	}
	build() {
		return this.encodedQuery;
	}
	static new(collection) {
		return new QueryBuilder({ collection });
	}
};
function q(collection) {
	return QueryBuilder.new(collection);
}

//#endregion
export { QueryBuilder, q };